module.exports = __webpack_public_path__ + "static/media/lighning.9c67515f.jpg";